export default function overrideMuiStyle(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: "4px",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          paddingTop: "2px",
          paddingBottom: "2px",
          "&.Mui-selected": {
            // color: theme.menuSelected,
            backgroundColor: "#E3F2FD",
            "&:hover": {
              backgroundColor: "#E3F2FD",
            },
            "& .MuiListItemIcon-root": {
              // color: theme.menuSelected,
            },
          },
          "&:hover": {
            backgroundColor: "#E3F2FD",
            // color: theme.menuSelected,
            "& .MuiListItemIcon-root": {
              // color: theme.menuSelected,
            },
          },
        },
      },
    },
    // MuiOutlinedInput: {
    //   styleOverrides: {
    //     root: {
    //       "&.Mui-focused ": {
    //         backgroundColor: "yellow",
    //         outline: "none",
    //       },
    //     },
    //   },
    // },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          //color: theme.darkTextPrimary,
          minWidth: "36px",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        text: {
          fontSize: 3,
          backgroundColor: "#fefefe",
        },
        root: {
          fontSize: 4,
        },
        primary: {
          fontSize: 5,
          // color: theme.textDark,
        },
        secondary: {
          fontSize: 2,
        },
      },
    },
  };
}
